import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Link, Typography } from '@mui/material';
import Hero from '../../sections/Hero';
import ServiceAreaMap from '../../sections/ServiceAreaMap';
import QuoteRequestForm from '../../sections/QuoteRequestForm';
import { junkRemovalCities } from '../junk-removal/junkRemovalCities';

const ServiceAreasPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Service Areas</title>
        <meta
          name="description"
          content="JBR Delivery LLC serves Northeast Wisconsin including Green Bay, Door County, Appleton, Oshkosh, and surrounding areas. Proud to serve Sturgeon Bay, Fish Creek, Sister Bay, and all of Door County."
        />
      </Helmet>

      <Hero 
        title="Our Service Areas"
        subtitle="JBR Delivery provides services throughout Northeast Wisconsin and Door County"
        backgroundImage="/assets/images/service-areas-bg.jpg"
        showQuickForm={false}
      />

      <Box component="section" py={8}>
        <Container maxWidth="lg">
          <Typography variant="h2" component="h2" gutterBottom>
            Areas We Serve
          </Typography>
          <Typography variant="body1" paragraph>
            JBR Delivery LLC is proud to serve communities throughout Northeast Wisconsin and Door County. Our primary service areas include Green Bay, Appleton, Oshkosh, and all surrounding communities. We're especially proud to serve the entire Door County peninsula, including Sturgeon Bay, Fish Creek, Egg Harbor, Sister Bay, and Baileys Harbor.
          </Typography>
          <Typography variant="body1" paragraph>
            Whether you're a Door County resident, vacation homeowner, or business, we provide reliable delivery, junk removal, and moving services. We're committed to serving both residential and commercial clients throughout the region. If you're unsure whether we service your area, please contact us!
          </Typography>
          
          <Typography variant="body1" paragraph>
            Junk removal by area:{' '}
            {junkRemovalCities.map((city, index) => (
              <React.Fragment key={city.slug}>
                {index > 0 && ' · '}
                <Link component={RouterLink} to={`/junk-removal/${city.slug}`}>
                  {city.name}
                </Link>
              </React.Fragment>
            ))}
          </Typography>

          <Box mt={4}>
            <ServiceAreaMap />
          </Box>
        </Container>
      </Box>

      <QuoteRequestForm />
    </>
  );
};

export default ServiceAreasPage;
